var Address = (function (CheckoutApiModel) {
	return CheckoutApiModel.extend({
		idAttribute: 'ID',
		select: function () {
			return this._api.applyDeliveryAddress(this.get('ID'), CheckoutSettings.imageSize).done(this._updateCheckout);
		}
	});
})(CheckoutApiModel);
